<template>
    <v-container fluid>
        <v-layout row wrap justify-start align-start v-if="multi">                                                       
            <v-flex d-flex xs8 v-for="(res,index) in result" :key="index">  
                <v-card color="transparent" flat hover>
                    
                    <v-card-text>                        
                        <v-layout row wrap>
                            <v-flex xs10>
                                
                                <span><b v-html="getTitle(res)"></b></span></br>
                                <span v-html="getSubTitle(res)"></span>
                            </v-flex>
                            <v-flex xs2>
                                <v-btn small fab flat v-on:click.stop="remove(res)">
                                    <v-icon small class="mt-1" >
                                        delete
                                    </v-icon>    
                                </v-btn>
                            </v-flex>
                        </v-layout>
                        
                    </v-card-text>
                </v-card>
            </v-flex>
            </v-layout>
            <v-layout row wrap justify-start align-start v-else>
            <v-flex d-flex xs8 v-if="result">  
                <v-card color="transparent" flat hover>
                    <v-card-text>
                        <v-layout row wrap>
                            <v-flex xs10>
                                
                                <span><b v-html="getTitle(result)"></b></span></br>
                                <span v-html="getSubTitle(result)"></span>
                            </v-flex>
                            <v-flex xs2>
                                <v-btn small fab flat v-on:click.stop="remove(result)">
                                    <v-icon small class="mt-1" >
                                        delete
                                    </v-icon>    
                                </v-btn>
                            </v-flex>
                        </v-layout>                        
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>  
    </v-container>
</template>

<script>
    export default {   
   
    props: [
        'result',
        'attributes',
        'itemsnamespace'
    ],
    methods: {
                
        remove (item) {               
            this.$emit('itemremoved',item)
               
        },
        getTitle (id) {
            return this.$store.getters[this.itemsnamespace+ "/getsingle"](id)[this.attributes.displaytitle]
        },
        getSubTitle (id) {
            return this.$store.getters[this.itemsnamespace+ "/getsingle"](id)[this.attributes.displaysubtitle]
        },
                      
    },
    computed:{
        multi () {            
            return this.attributes.multiple
        },
        
        
    }
    
    
}
</script>